import React,{useState,useEffect,useContext} from 'react';
import {Doughnut} from 'react-chartjs-2';
import {ChartContext} from './Map';
import {Chart as ChartJS,registerables} from 'chart.js';
ChartJS.register(...registerables);

export default function BarChart(){
    const data=useContext(ChartContext);
    const [chartData, setChartData] = useState([]);

  useEffect(() => {
    if (data.length) {
      setChartData(data.slice(1, 5));
    }
  }, [data]);
    return(
        <>
            <Doughnut
                data={{
                    labels:['Ruto','Raila','Wajackoyah','Mwaure'],
                    datasets:[{
                        label:'Total Vote Percentage',
                        data:chartData,
                        backgroundColor:[
                            'rgb(255,255,0)',
                            'rgb(0,0,255)',
                            'rgb(64,145,108)',
                            'rgb(94,84,142)'
                        ]
                    }]
                }}
                options={{
                    plugins:{
                        
                        legend:{
                            display:false
                        },
                        title:{
                            display:false,
                        },
                        responsive:true,
                        maintainAspectRatio:true
                    }
                }}
            />
        </>
    );
}